import React from 'react';
import './Css/About.css';
import { Container, Row, Col } from 'react-bootstrap';
import siteConfig from '../config/site.config';

export const About = () => {
  const { author } = siteConfig;

  return (
    <section className="about" id="about">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-4 mb-lg-0">
            <div className="about-img">
              <img src="https://avatars.githubusercontent.com/u/81242756?s=400&u=4658f285167e173f4ea50b7111cde1cda4d2819c&v=4" alt="xqsadness Profile" />
            </div>
          </Col>
          <Col lg={6}>
            <div className="about-content">
              <h2>About Me</h2>
              <p className="about-text">
                Hi, I'm <strong>xqsadness</strong>, an iOS Developer specializing in building native mobile applications with Swift.
                My main focus is on creating efficient, user-friendly iOS apps while occasionally
                exploring web technologies to broaden my development perspective.
              </p>

              <div className="personal-info mt-4">
                <Row>
                  <Col md={6}>
                    <div className="info-item">
                      <h5>Name:</h5>
                      <p>{author.name}</p>
                    </div>
                    <div className="info-item">
                      <h5>Role:</h5>
                      <p>{author.role}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="info-item">
                      <h5>Email:</h5>
                      <p>{author.email}</p>
                    </div>
                    <div className="info-item">
                      <h5>GitHub:</h5>
                      <p><a href={author.github} target="_blank" rel="noopener noreferrer">{author.github}</a></p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
} 